import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminUser } from '../models/admin-user.types';

@Injectable()
export class AdminManagementService {
  private readonly adminUsersUrl = '/api/nucleus/admin/user';

  constructor(private readonly http: HttpClient) {}

  getAdminUsers(): Observable<AdminUser[]> {
    return this.http.get<AdminUser[]>(`${this.adminUsersUrl}/list`);
  }

  createAdminUser(email: string): Observable<AdminUser> {
    return this.http.post<AdminUser>(
      `${this.adminUsersUrl}/${encodeURIComponent(email)}`,
      null,
    );
  }
}
